import React from 'react';
import Helmet from 'react-helmet';

import { getAsset } from '../../../util/assets';
import getConfig from '../../../util/config';

const OnboardingLandingChurchHeadMeta = () => {
  const {
    app: { pageUrl },
  } = getConfig();

  return (
    <Helmet>
      <title>Your Church Photos, Waldo-fied!</title>
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Your Church Photos, Waldo-fied!" />
      <meta
        property="og:description"
        content="Hi! I’m Waldo, A secure and easy-to-use photo management platform for churches, powered by facial recognition and mobile photo delivery!"
      />
      <meta
        property="og:image"
        content={getAsset('/church-landing-hero-1.jpg')}
      />
    </Helmet>
  );
};

export default OnboardingLandingChurchHeadMeta;
